import { useRef } from 'react';
import { mediaUrl } from './config';
import { useFocusTrap } from './useFocusTrap';
import { NAVY, ORANGE, BLUE } from './theme';

function DashboardIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="12" width="4" height="8" rx="1"/><rect x="10" y="7" width="4" height="13" rx="1"/><rect x="16" y="3" width="4" height="17" rx="1"/>
    </svg>
  );
}
function ProfileIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  );
}
function StoreIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M9 20v-6h6v6"/>
    </svg>
  );
}
function BoxIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>
    </svg>
  );
}
function TrackIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  );
}
function HeartIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}
function PinIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  );
}
function GearIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  );
}
function BellIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  );
}
function LogoutIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  );
}
function ChevronIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  );
}

export default function AccountSheet({ user, wishlistCount, unreadNotifCount, isSeller, onNavigate, onLogout, onClose }) {
  const items = [
    { key: 'dashboard', label: 'My Dashboard', color: BLUE, icon: <DashboardIcon /> },
    { key: 'profile', label: 'My Profile', color: NAVY, icon: <ProfileIcon /> },
    isSeller && { key: 'seller-portal', label: 'Seller Portal', color: NAVY, icon: <StoreIcon /> },
    { key: 'orders', label: 'My Orders', color: ORANGE, icon: <BoxIcon /> },
    { key: 'track-order', label: 'Track Order', color: ORANGE, icon: <TrackIcon />, sub: true },
    { key: 'wishlist', label: 'Wishlist', color: ORANGE, icon: <HeartIcon />, badge: wishlistCount },
    { key: 'address', label: 'My Address', color: NAVY, icon: <PinIcon /> },
    { key: 'settings', label: 'Settings', color: NAVY, icon: <GearIcon /> },
    { key: 'notifications', label: 'Notifications', color: ORANGE, icon: <BellIcon />, badge: unreadNotifCount },
  ].filter(Boolean);

  const sheetRef = useRef(null);
  useFocusTrap(sheetRef, true);

  return (
    <div className="mas-backdrop" onClick={onClose} onKeyDown={e => { if (e.key === 'Escape') onClose(); }}>
      <div ref={sheetRef} tabIndex={-1} className="mas-sheet" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Account menu">
        <div className="mas-header">
          {user?.avatar ? (
            <img src={mediaUrl(user.avatar)} alt={user.name} className="mas-avatar mas-avatar-img" />
          ) : (
            <span className="mas-avatar">{user?.name?.charAt(0).toUpperCase() || '?'}</span>
          )}
          <div className="mas-header-text">
            <div className="mas-hello">Hello, {user?.name?.split(' ')[0]}</div>
            <div className="mas-sub">Welcome back!</div>
          </div>
          <button className="mas-close" onClick={onClose} aria-label="Close menu">×</button>
        </div>

        <div className="mas-list">
          {items.map((item) => (
            <button key={item.key} className={`mas-item${item.sub ? ' mas-item-sub' : ''}`} onClick={() => { onNavigate(item.key); onClose(); }}>
              <span className="mas-item-icon" style={{ background: item.color }}>{item.icon}</span>
              <span className="mas-item-label">{item.label}</span>
              {item.badge > 0 && <span className="mas-item-badge">{item.badge}</span>}
              <span className="mas-chevron"><ChevronIcon /></span>
            </button>
          ))}
        </div>

        <div className="mas-divider" />
        <button className="mas-logout" onClick={() => { onClose(); onLogout(); }}>
          <LogoutIcon /> Logout
        </button>
      </div>
    </div>
  );
}
